<template>
  <div class="mian">
    <div class="navTop">
      <Nav :title="navTitle"></Nav>
    </div>
    <div class="body">
      <!-- <form class="search" action="/">
        <van-search
          v-model="value"
          show-action
          shape="round"
          placeholder="搜索"
          @input="showCancel"
          @search="onSearch"
          @cancel="onCancel"
        />
      </form> -->
      <div class="itemList" v-for="(item, index) in dypeList" :key="index">
        <!-- <van-cell class="cell" :title=item is-link @click="goRegistration(item)"/> -->
        <van-cell
          v-for="(i, key) in reglevelList"
          :key="key"
          class="cell"
          :title="item.deptName"
          is-link
          @click="godetail_No(item)"
        />
        <!-- {{item}} -->
        <div class="cellBorder"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "../../components/nav.vue";
import { Toast } from "vant";
export default {
  components: {
    Nav,
  },
  data() {
    return {
      reglevelList: [],
      navTitle: "科室选择",
      value: "",
      dypeList: [],
      // show:false,
      list: [
        // "白州名医门诊",
        // "内科",
        // "高级专家诊疗部(特需门诊)",
        // "心内二科门诊",
        // "消化科一病区门诊",
        // "消化科二病区门诊",
        // "神内一科门诊",
        // "神内二科门诊",
        // "呼吸与危重症医学科门诊",
        // "慢性阻塞性肺疾病专病门诊",
        // "支气管哮喘专病门诊",
        // "睡眠呼吸疾病专病门诊",
        // "肺癌专病门诊",
        // "肺栓塞与肺血管疾病专病门诊",
        // "肺结节多学科门诊",
        // "妇科门诊诊断室",
        // "呼吸与危重症医学科门诊",
        // "慢性阻塞性肺疾病专病门诊",
        // "支气管哮喘专病门诊",
        // "睡眠呼吸疾病专病门诊",
        // "肺癌专病门诊",
        // "肺栓塞与肺血管疾病专病门诊",
        // "肺结节多学科门诊",
        // "妇科门诊诊断室",
      ],
    };
  },

  mounted() {
    // this.getDeptList();
    this.getDeptList();
    this.NO_getregLevelIdInfo();
  },
  methods: {
    //跳转到确定挂号页
    godetail_No(item) {

      this.$router.push({
        path: "/no_details",
        query: {
          registerInfo: {
            dept_deptId: item.deptId,
            dept_name: item.deptName,
            regLevelName: this.reglevelList[0].regLevelName,
            regLevelId: this.reglevelList[0].regLevelId,
            regFee: this.reglevelList[0].regFee,
          },
        },
      });
    },
    //无排班挂号级别(门诊类型)
    async NO_getregLevelIdInfo() {
      // this.dept_id = deptId;
      // this.method_depy_type = this.dypeList[index];
      // this.name = name;
      // console.log(this.method_depy_type)
      try {
        this.$showLoad();
        let url = "/register/queryallreglevel";
        // console.log(R_data)
        await this.$axios_request.request_data(
          "nodeserver",
          url,
          "POST",
          null,
          async (data) => {
            // console.log(data.data)
            this.reglevelList = data.data.data.data;
            // console.log(this.       reglevelList)
            this.reglevelList = this.reglevelList.filter((item) => {
              return item.regLevelName == "免挂号费";
            });
            this.$hideLoad();
          }
        );
      } catch (error) {
        // console.log(error);
        this.$hideLoad();
      }
    },
    //获取科室列表
    async getDeptList() {
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/register/querydept";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            this.dypeList = data.data.data;
            // console.log(this.dypeList[0])
            for (let i = 0; i < this.dypeList.length; i++) {
              this.list.push(this.dypeList[i].deptName);
            }

            // console.log( this.dypeList)
            // console.log(this.dypeList)
            /**
						 挂号排班类型
						@register_sched
						挂号级别
						@register_level
						*/
            this.$hideLoad();
          }
        );
      } catch (error) {
        // console.log(error);
        this.$hideLoad();
      }
    },

    fuzzyQuery(list, keyWord) {
      var arr = [];
      for (var i = 0; i < list.length; i++) {
        if (list[i].indexOf(keyWord) >= 0) {
          arr.push(list[i]);
        }
      }
      return arr;
    },
    onSearch(val) {
      this.list = this.fuzzyQuery(this.list, val);
    },
    onCancel() {
      // Toast('取消');
      window.location.reload();
    },
    //预约挂号页（暂时没用）
    // goRegistration(item){
    // 	this.$router.push({
    // 		name:"registration",
    // 		query:{
    // 			data:item
    // 		}
    // 	})
    // },
    showCancel() {},
  },
};
</script>

<style scoped>
/* div {
	border: 1px #000 solid; 
 } */
.mian {
  width: 100vw;
  margin-bottom: 15px;
  /* background: #000000; */
}
.navTop {
  width: 100%;
  position: fixed;
  top: 0;
}
.topBox {
  width: 100%;
  height: 50px;
}
.body {
  position: fixed;
  top: 50px;
  width: 100%;
  overflow: scroll;
  height: 93vh;
  background-color: rgb(239, 239, 244);

  /* border: 1px #000 solid; */
}
.itemList {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* font-size: 20px; */
}
.cell {
  /* border-bottom: solid 1px rgb(200, 200, 200); */
  margin: 0 2.5%;
  width: 100%;
}
.cellBorder {
  width: 89%;
  height: 2px;
  background-color: rgba(228, 226, 226, 0.76);
}
.search {
  margin: 0 2.5%;
}
.van-cell {
  font-size: 20px;
}
.van-icon {
  font-size: 20px;
}
.van-search__action {
  color: rgb(74, 194, 180);
  font-size: 16px;
}
.van-search {
  background-color: rgb(239, 239, 244);
  padding-left: 5px;
}
.van-search__content {
  background-color: #fff;
}
</style>